import { __decorate } from "tslib";
import { TaskStatus, NodeType } from '../../Types/TaskStatus';
import { NodeExecutorMetadata } from '../NodeMetadata';
/**
 * 序列节点执行器
 *
 * 按顺序执行子节点，全部成功才成功，任一失败则失败
 */
let SequenceExecutor = class SequenceExecutor {
    execute(context) {
        const { nodeData, state } = context;
        if (!nodeData.children || nodeData.children.length === 0) {
            return TaskStatus.Success;
        }
        while (state.currentChildIndex < nodeData.children.length) {
            const childId = nodeData.children[state.currentChildIndex];
            const status = context.executeChild(childId);
            if (status === TaskStatus.Running) {
                return TaskStatus.Running;
            }
            if (status === TaskStatus.Failure) {
                state.currentChildIndex = 0;
                return TaskStatus.Failure;
            }
            state.currentChildIndex++;
        }
        state.currentChildIndex = 0;
        return TaskStatus.Success;
    }
    reset(context) {
        context.state.currentChildIndex = 0;
    }
};
SequenceExecutor = __decorate([
    NodeExecutorMetadata({
        implementationType: 'Sequence',
        nodeType: NodeType.Composite,
        displayName: '序列',
        description: '按顺序执行子节点，全部成功才成功',
        category: 'Composite'
    })
], SequenceExecutor);
export { SequenceExecutor };
//# sourceMappingURL=SequenceExecutor.js.map